// extracted by mini-css-extract-plugin
export default {"kEmpty":"KEmpty__kEmpty___RAo0_","kEmptyDesc":"KEmpty__kEmptyDesc___t1qkg"};